/** 
 * © 2025 COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 'CONTPAQi'. Todos los derechos reservados. 
 * Este código fuente constituye una obra original protegida por la legislación nacional e internacional en materia de propiedad intelectual. 
 * Su reproducción, distribución, comunicación pública, transformación, descompilación, ingeniería inversa o cualquier uso no autorizado, 
 * total o parcial, se encuentra expresamente prohibido sin la previa autorización por escrito de COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 
 * El uso indebido de este software puede ser constitutivo de delitos y dará lugar a las responsabilidades civiles y penales correspondientes. 
*/ 
 
import { createStore, applyMiddleware } from "redux";
import createSagaMiddleware from "redux-saga";

import myReducer from "./reducers/index";
import mySaga from "./sagas/index";

//Dev tools middleware
const reduxDevTools = window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__();

//Create the Saga middleware
const sagaMiddleware = createSagaMiddleware();

//Mount it on the Store
export default createStore(myReducer, applyMiddleware(sagaMiddleware), reduxDevTools);

//Then run the Saga
sagaMiddleware.run(mySaga);